<template>
  <div>
    <custom-actions>
      <template #header>
        <el-button type="primary" v-if="hasExport" @click="onExport">导出</el-button>
      </template>
      <el-form :model="searchForm" ref="formData" inline class="global-form-label-width"
               label-width="100px">
        <el-form-item label="出库单号" prop="outboundNumber">
          <el-input clearable v-model="searchForm.outboundNumber" placeholder="出库单号"/>
        </el-form-item>
        <el-form-item label="客户" prop="userId">
          <el-select v-model="searchForm.userId" filterable :clearable="true">
            <el-option :label="item.userName" :value="item.userId" v-for="item in userList"
                       :key="item.userId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品种规格" prop="specName">
          <el-input clearable v-model="searchForm.specName" placeholder="品种规格"/>
        </el-form-item>
        <el-form-item label="车船号" prop="vehicleNumber">
          <el-input clearable v-model="searchForm.vehicleNumber" placeholder="车船号"/>
        </el-form-item>
        <el-form-item label="司机姓名" prop="driverName">
          <el-input clearable v-model="searchForm.driverName" placeholder="司机姓名"/>
        </el-form-item>
        <el-form-item label="发货日期">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format='yyyy-MM-dd'
            value-format="yyyy-MM-dd"
            @change="handleDateChange"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
          <el-button @click="onReset">重置</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData">
        <el-table-column min-width="230" label="出库单号" prop="outboundNumber">
          <template v-slot="{ row }">
            <el-button type="text" @click="$router.push('/deliveryOrder/detail?pickupId=' + row.pickupId)">{{ row.outboundNumber }}</el-button>
            <el-button type="text" @click.stop="copyText(row.outboundNumber)">复制</el-button>
          </template>
        </el-table-column>
        <el-table-column min-width="140" :show-overflow-tooltip="true" label="发货日期" prop="ctime"></el-table-column>
        <el-table-column min-width="180" :show-overflow-tooltip="true" label="品种规格" prop="specName"></el-table-column>
        <el-table-column min-width="120" :show-overflow-tooltip="true" label="数量" prop="quantity">
          <template v-slot="{ row }">
            {{ row.quantity || 0 }}{{ row.unit || '' }}
          </template>
        </el-table-column>
        <el-table-column min-width="160" :show-overflow-tooltip="true" label="生产日期" prop="productionDate"></el-table-column>
        <el-table-column min-width="140" :show-overflow-tooltip="true" label="保质期" prop="shelfLife"></el-table-column>
        <el-table-column min-width="120" :show-overflow-tooltip="true" label="罐号" prop="tankNumber"></el-table-column>
        <el-table-column min-width="140" :show-overflow-tooltip="true" label="车船号" prop="vehicleNumber"></el-table-column>
        <el-table-column min-width="120" :show-overflow-tooltip="true" label="司机姓名" prop="driverName"></el-table-column>
        <el-table-column min-width="140" :show-overflow-tooltip="true" label="司机号码" prop="driverMobile"></el-table-column>
        <el-table-column min-width="140" :show-overflow-tooltip="true" label="客户联系人" prop="contactName"></el-table-column>
        <el-table-column min-width="140" :show-overflow-tooltip="true" label="客户" prop="userName"></el-table-column>
        <el-table-column min-width="220" :show-overflow-tooltip="true" label="客户地址" prop="customerAddress"></el-table-column>
        <el-table-column min-width="140" :show-overflow-tooltip="true" label="客户号码" prop="customerMobile"></el-table-column>

        <el-table-column width="100" label="操作" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" v-if="hasEdit" @click="openEditDialog(row)">编辑</el-button>
            <el-button type="text" @click="$router.push('/shipRecord/detail?outboundId=' + row.outboundId)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="mt15" :current-page.sync="page" background layout="total, prev, pager, next" :total="total"
                     @current-change="loadData">
      </el-pagination>
    </el-card>

    <!-- 编辑弹窗 -->
    <el-dialog title="编辑出库单" :visible.sync="editVisible" width="660px" @close="handleDialogClose">
      <el-form ref="editFormRef" :model="editForm" label-width="120px">
        <el-form-item label="生产日期" prop="productionDateArr">
          <el-date-picker
            v-model="editForm.productionDateArr"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            clearable
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="保质期" prop="shelfLife">
          <el-input v-model="editForm.shelfLife" placeholder="例如：12个月" clearable></el-input>
        </el-form-item>
        <!-- 新增：罐号 -->
        <el-form-item label="罐号" prop="tankNumber">
          <el-input v-model="editForm.tankNumber" placeholder="请输入罐号" clearable></el-input>
        </el-form-item>
        <!-- 新增：附件 -->
        <el-form-item label="附件" prop="fileList">
          <media-upload :limit="10" v-model="editForm.fileList"></media-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" :loading="editLoading" @click="submitEdit">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import keepAlive from '@/mixins/keepAlive'
export default {
  name: 'ShipRecord',
  mixins: [keepAlive],
  data() {
    return {
      userList: [],
      tableData: [],
      page: 1,
      total: 0,
      loading: false,
      dateRange: null,
      searchForm: {
        outboundNumber: '',
        userId: '',
        specName: '',
        vehicleNumber: '',
        driverName: '',
        startDate: '',
        endDate: ''
      },
      editVisible: false,
      editLoading: false,
      editForm: {
        outboundId: '',
        productionDateArr: null, // 弹窗绑定区间数组
        shelfLife: '',
        tankNumber: '',
        fileList: []
      }
    }
  },
  created() {
    this.loadData()
    this.loadUserList()
  },
  computed: {
    buttonList() {
      return this.$store.state.buttonList.map(item => item.butCode)
    },
    hasExport() {
      return this.buttonList.includes('export')
    },
    hasEdit() {
      return this.buttonList.includes('edit')
    }
  },
  methods: {
    // 打开编辑弹窗，回显数据
    openEditDialog(row) {
      this.editVisible = true
      this.editForm.outboundId = row.outboundId
      this.editForm.tankNumber = row.tankNumber || ''
      this.editForm.shelfLife = row.shelfLife
      // 回显：字符串 yyyy‑mm‑dd~yyyy‑mm‑dd 拆分为数组
      if (row.productionDate) {
        this.editForm.productionDateArr = row.productionDate.split('~')
      } else {
        this.editForm.productionDateArr = null
      }

      this.$axios
        .get(this.$apis.shipRecord.selectYxOutboundOrderByOutboundId, {
          params: { outboundId: row.outboundId }
        })
        .then(res => {
          this.editForm.fileList = res.fileList || []
        })
    },
    // 弹窗关闭，清除校验
    handleDialogClose() {
      this.$refs.editFormRef && this.$refs.editFormRef.clearValidate()
    },
    // 提交编辑：数组拼接成 yyyy‑mm‑dd~yyyy‑mm‑dd
    async submitEdit() {
      this.editLoading = true
      const payload = { ...this.editForm }
      // 组装传给后端的 productionDate 字符串
      if (payload.productionDateArr && Array.isArray(payload.productionDateArr) && payload.productionDateArr.length === 2) {
        payload.productionDate = payload.productionDateArr.join('~')
      } else {
        payload.productionDate = ''
      }
      // 删除前端临时数组字段，不传给后端
      delete payload.productionDateArr

      try {
        await this.$axios.post(this.$apis.shipRecord.updateYxOutboundOrder, payload)
        this.$message.success('修改成功')
        this.editVisible = false
        this.loadData()
      } catch (err) {
        console.error(err)
      } finally {
        this.editLoading = false
      }
    },
    // 复制文本
    async copyText(text) {
      if (!text) return
      try {
        await navigator.clipboard.writeText(text)
        this.$message.success('复制成功')
      } catch (err) {
        // 兼容低版本浏览器剪贴板
        const input = document.createElement('input')
        input.value = text
        document.body.appendChild(input)
        input.select()
        document.execCommand('copy')
        document.body.removeChild(input)
        this.$message.success('复制成功')
      }
    },
    handleDateChange(val) {
      if (val && Array.isArray(val)) {
        this.searchForm.startDate = val[0]
        this.searchForm.endDate = val[1]
      } else {
        this.searchForm.startDate = ''
        this.searchForm.endDate = ''
      }
    },
    loadUserList() {
      this.$axios.get(this.$apis.system.selectSysUserByPage, {
        userType: '2,3,4',
        page: 1,
        size: 9999
      }).then(res => {
        this.userList = res.list
      })
    },
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.shipRecord.selectYxOutboundOrderByPage, {
        page: this.page,
        size: 10,
        ...this.searchForm
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    onSearch() {
      this.page = 1
      this.loadData()
    },
    onReset() {
      this.$refs.formData.resetFields()
      this.dateRange = null
      this.searchForm.startDate = ''
      this.searchForm.endDate = ''
      this.onSearch()
    },
    downloadFile(data, fileName) {
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const downloadElement = document.createElement('a')
      const href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      downloadElement.download = decodeURIComponent(fileName)
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      window.URL.revokeObjectURL(href)
    },
    onExport() {
      const loadingInstance = this.$loading({
        text: '正在导出...',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      this.$axios.post(this.$apis.shipRecord.exportYxOutboundOrder, this.searchForm, {
        responseType: 'blob'
      }).then(res => {
        if (res) {
          const contentDisposition = res.headers['content-disposition']
          let fileName = '出库确认单.xls'
          if (contentDisposition) {
            fileName = contentDisposition
              .substring(contentDisposition.indexOf('filename'))
              .split('=')[1]
          }
          this.downloadFile(res.data, fileName)
        }
      }).catch(error => {
        console.error('导出失败:', error)
      }).finally(() => {
        loadingInstance.close()
      })
    }
  }
}
</script>
